<template>
  <!-- Very unusual margin, but that's what the mockup shows -->
  <app-empty-state
    v-if="isRootFolder"
    class="mt-12"
    module="documents"
    translation-key-prefix="project.documents.DocumentsEmptyState"
  />

  <AppCardEmptyState
    v-else
    :title="emptyStateTitle"
    :text="emptyStateText"
    data-locator="empty-state"
  />
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import AppCardEmptyState from '@/common/AppCardEmptyState.vue'
import { ROOT_FOLDER, RECENT_FOLDER } from '@/project/documents/constants/special-folders'

export default {
  name: 'DocumentsEmptyState',
  components: {
    AppCardEmptyState,
  },
  data () {
    return {
      ROOT_FOLDER,
      RECENT_FOLDER,
    }
  },
  computed: {
    ...mapState('documents', ['paginatedDocumentsCurrentFolderId']),
    ...mapGetters('documents', ['isRootFolder', 'isRecentFolder', 'isQaFolder']),
    emptyStateTitle () {
      if (this.isRecentFolder) {
        return this.$t('project.documents.DocumentsEmptyState.noRecentFilesTitle')
      }
      if (this.isQaFolder) {
        return this.$t('project.documents.DocumentsEmptyState.noQaFilesTitle')
      }
      return this.$t('project.documents.DocumentsEmptyState.noTodoFilesTitle')
    },
    emptyStateText () {
      if (this.isRecentFolder) {
        return this.$t('project.documents.DocumentsEmptyState.noFilesText')
      }
      if (this.isQaFolder) {
        return this.$t('project.documents.DocumentsEmptyState.noQaFilesText')
      }
      return this.$t('project.documents.DocumentsEmptyState.noTodoFilesText')
    },
  },
}
</script>
